window.pageDetailFormatter = function(value, row) {
    if (!row.children || row.children.length === 0) {
        return '';
    }

    const rows = row.children
        .map(function(child) {
            const title = $('<div/>').text(child.title || '-').html();
            const show = $('<div/>').text(child.show || '#').html();
            const edit = $('<div/>').text(child.edit || '#').html();

            return '<tr>'
                + '<td class="text-center col-md-1"><a href="' + show + '"><i class="fas fa-eye"></i></a></td>'
                + '<td>' + title + '</td>'
                + '<td class="text-end"><a href="' + edit + '" class="btn btn-sm btn-outline-primary">Edit</a></td>'
                + '</tr>';
        })
        .join('');

    return '<div class="table-responsive"><table class="table table-sm table-striped mb-0">'
        + '<thead><tr><th class="text-center col-md-1"></th><th>Title</th><th class="text-end"></th></tr></thead>'
        + '<tbody>' + rows + '</tbody>'
        + '</table></div>';
};

window.pageDetailPostBody = function() {
    const $table = $('#table_pages');
    const rows = $table.bootstrapTable('getData', {useCurrentPage: true}) || [];

    $table.find('tbody > tr[data-index]').each(function() {
        const $row = $(this);
        const index = Number($row.data('index'));
        const row = rows[index];
        const hasChildren = Array.isArray(row?.children) && row.children.length > 0;
        const $icon = $row.find('td.detail .detail-icon');

        if (!hasChildren) {
            $icon.addClass('text-muted').css({
                opacity: 0.45,
                cursor: 'not-allowed',
                pointerEvents: 'none'
            });
        }
    });
};
